import {
  GET_DEFAULT_ASSIGNMENT,
  GET_DEFAULT_ASSIGNMENT_FAIL,
  GET_DEFAULT_ASSIGNMENT_SUCCESS,
  GET_DEFAULT_ASSIGNMENTS,
  GET_DEFAULT_ASSIGNMENTS_FAIL,
  GET_DEFAULT_ASSIGNMENTS_SUCCESS,
  ADD_NEW_DEFAULT_ASSIGNMENT,
  ADD_DEFAULT_ASSIGNMENT_SUCCESS,
  ADD_DEFAULT_ASSIGNMENT_FAIL,
  UPDATE_DEFAULT_ASSIGNMENT,
  UPDATE_DEFAULT_ASSIGNMENT_SUCCESS,
  UPDATE_DEFAULT_ASSIGNMENT_FAIL,
  DELETE_DEFAULT_ASSIGNMENT,
  DELETE_DEFAULT_ASSIGNMENT_SUCCESS,
  DELETE_DEFAULT_ASSIGNMENT_FAIL,
  SET_STATE_DEFAULT_ASSIGNMENT,
  UPDATE_DEFAULT_ASSIGNMENT_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_DEFAULT_ASSIGNMENT,
  payload: loading,
})

export const getDefaultAssignments = ( params ) => ({
  type: GET_DEFAULT_ASSIGNMENTS,
  payload: { params },
})

export const getDefaultAssignmentsSuccess = (defaultAssignments, totalPages, currentPage) => ({
  type: GET_DEFAULT_ASSIGNMENTS_SUCCESS,
  payload: { defaultAssignments, total: totalPages, currentPage }
})

export const getDefaultAssignmentsFail = error => ({
  type: GET_DEFAULT_ASSIGNMENTS_FAIL,
  payload: error,
})

export const addNewDefaultAssignment = defaultAssignment => ({
  type: ADD_NEW_DEFAULT_ASSIGNMENT,
  payload: defaultAssignment,
})

export const addDefaultAssignmentSuccess = defaultAssignment => ({
  type: ADD_DEFAULT_ASSIGNMENT_SUCCESS,
  payload: defaultAssignment,
})  

export const addDefaultAssignmentFail = error => ({
  type: ADD_DEFAULT_ASSIGNMENT_FAIL,
  payload: error,
})

export const updateDefaultAssignment = defaultAssignment => ({
  type: UPDATE_DEFAULT_ASSIGNMENT,
  payload: defaultAssignment,
})

export const updateDefaultAssignmentStatus = defaultAssignment => ({
  type: UPDATE_DEFAULT_ASSIGNMENT_STATUS,
  payload: defaultAssignment,
})

export const updateDefaultAssignmentSuccess = defaultAssignment => ({
  type: UPDATE_DEFAULT_ASSIGNMENT_SUCCESS,
  payload: defaultAssignment,
})

export const updateDefaultAssignmentFail = error => ({
  type: UPDATE_DEFAULT_ASSIGNMENT_FAIL,
  payload: error,
})

export const deleteDefaultAssignment = defaultAssignment => ({
  type: DELETE_DEFAULT_ASSIGNMENT,
  payload: defaultAssignment,
})

export const deleteDefaultAssignmentSuccess = id => ({
  type: DELETE_DEFAULT_ASSIGNMENT_SUCCESS,
  id,
})

export const deleteDefaultAssignmentFail = error => ({
  type: DELETE_DEFAULT_ASSIGNMENT_FAIL,
  payload: error,
})

export const getDefaultAssignment = () => ({
  type: GET_DEFAULT_ASSIGNMENT,
})

export const getDefaultAssignmentSuccess = defaultAssignment => ({
  type: GET_DEFAULT_ASSIGNMENT_SUCCESS,
  payload: defaultAssignment,
})

export const getDefaultAssignmentFail = error => ({
  type: GET_DEFAULT_ASSIGNMENT_FAIL,
  payload: error,
})
